$(function () {
    initGallery();
    initNav();
    sliderHeader();
    initMap();
    initSmoothScroll();
    oliebollen();
});

$(window).on('load', function () {
    initEqualHeights();
    initHeightsHalf();
    initMapsHeight();
});

$(window).resize(function () {
    clearTimeout($.data(this, 'resizeTimer'));
    $.data(this, 'resizeTimer', setTimeout(function () {
        initEqualHeights();
        initHeightsHalf();
        initMapsHeight();
    }, 100));
});

function initNav() {
    var $btn_navigation = $('header .nav-toggle'),
        $nav = $('header nav'),
        logo_height = $('header img').outerHeight();

    $btn_navigation.click(function (e) {
        e.stopPropagation();
        e.preventDefault();

        if ($(window).width() < 980) {
            $nav.slideToggle();
        }
    });

    if ($nav.find('ul').length > 0) {
        $li = $nav.find('li');
        // $li.find('ul').hide();
        $li.has('ul').children('a').click(function (e) {

            $(this).closest('ul').children('li').find('ul').each(function (i, ul) {
                if ($(ul) != $(this).next('ul')) {
                    $(this).prev('a').children('span').removeClass('toggle');
                    if ($(window).width() < 1024) {

                        $(ul).slideUp();
                    }
                }
            });

            if ($(this).next('ul').css('visibility') === 'hidden' || $(this).next('ul').is(':hidden')) {
                e.preventDefault();

                if ($(window).width() < 1024) {
                    $(this).next('ul').slideDown();
                }
                $(this).children('span').addClass('toggle');
            }
        });
    }

    $(window).scroll(function () {
        if ($(this).scrollTop() > 0) {
            $('header').addClass('fixed');
        } else {
            $('header').removeClass('fixed');
        }
    });
}

function initMap() {
    if (document.querySelector('#gmap_locatie')) {
        var latlng = new google.maps.LatLng($('#gmap_locatie').data('lat'), $('#gmap_locatie').data('lng'));

        map = new google.maps.Map(document.getElementById("gmap_locatie"), {
            zoom: 18,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            center: latlng,
            scrollwheel: false
        });

        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: '/img/icon-map.png'
        });
    }
}

function sliderHeader() {
    if ($('.carousel-header').length) {
        $('.carousel-header').slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            dots: false,
            arrows: false,
        });
    }
}

function initMapsHeight() {
    if ($(window).width() > 0) {
        var maxHeight = 0;

        $('.adres-wrapper').each(function () {
            var height = $(this).height();
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        maxHeight = maxHeight;
        if ($(window).width() > 0) {
            $('#map').height(maxHeight + 100);
        }
    }
}

function initEqualHeights() {
    if ($('.equalHeights').length) {
        $('.equalHeights').each(function () {
            var parent = $(this),
                items = parent.data('equals').replace(/ /g, '').split(','),
                height;

            items.forEach(function (item) {
                height = 0;

                parent.find(item).each(function () {
                    if ($(this).outerHeight() > height) {
                        height = $(this).outerHeight();
                    }
                });

                if (parent.hasClass('no-mobile') && $(window).width() < 767) {
                    // Do nothing...
                } else {
                    parent.find(item).css({
                        minHeight: height
                    });
                }
            });
        });
    }
}


function initHeightsHalf() {
    if ($(window).width() > 991) {
        var maxHeight = 0;

        $('.half-wrapper .content-wrapper').each(function () {
            var height = $(this).outerHeight();
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        if ($(window).width() > 991) {
            maxHeight = maxHeight;
            $('.half-wrapper .image').height(maxHeight + 70);
        }
    }
}

function initSmoothScroll() {
    $('.scroll').each(function () {
        $(this).click(function (e) {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: $($(this).attr('href')).offset().top + $('header').outerHeight() - 160
            }, 1000);
        });
    });
}

function oliebollen() {
    if ($('#oliebollen').length) {
        timeCalculate();
        $('#date').on('change', timeCalculate)

        function timeCalculate() {
            var today = new Date();
            var count = 0;

            $('#date > option').each(function () {
                if (parseInt($(this).val()) < parseInt(today.getDate())) {

                    $(this).remove()
                }
            })

            $('#time > option').each(function () {
                count++;
                if ($('#date').val() == '31') {
                    if (count <= 5) {
                        $(this).removeAttr('disabled');
                    }
                    if (count > 6) {
                        $(this).attr('disabled', 'disabled');
                    }

                } else {
                    if (count <= 5) {
                        $(this).attr('disabled', 'disabled');
                    }
                    if (count === 6) {
                        $(this).prop('selected', true)
                    }

                }
            })
        }


        total();
        $('.quantity').on('change', function () {
            total();
        })

        function total() {

            var totalPrice = 0;

            $('.quantity').each(function () {
                var quantiy = $(this).val();
                var price = $(this).attr('data-price');
                totalPrice = totalPrice + (quantiy * parseFloat(price.replace(',', '.')))
            })
            totalPrice = new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'}).format(totalPrice);

            $('#totalPriceInput').val(totalPrice)
            $('#totalPrice').text(totalPrice)

        }

        $('#sendOliebollen').on('click', function () {
            var error = true;


            $('.quantity').each(function () {
                if ($(this).val() != 0) {
                    error = false;
                }
            })
            if (error) {
                $('#alertBestelling').removeClass('hidden');

            } else {
                $('#oliebollenForm').submit();

            }

        })
    }
}

function initGallery() {
    if ($('#gallery').length > 0) {
        // Lightbox
        $('.lightbox').magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            }
        });

    }
}